var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var Link_1 = __importDefault(require("./Link"));
exports.Link = Link_1.default;
exports.default = Link_1.default;
//# sourceMappingURL=index.js.map